import { toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fc81c46a")

_pushScopeId("data-v-fc81c46a")
const _hoisted_1 = { class: "account-info-panel" }
const _hoisted_2 = { class: "user-info-preview" }
const _hoisted_3 = { class: "display-name" }
const _hoisted_4 = { style: {"height":"45px","display":"flex","align-items":"center"} }
const _hoisted_5 = { style: {"font-size":"1em","font-family":"Oswald"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_ApplicationMenu = _resolveComponent("ApplicationMenu")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.infoTextRow0), 1)
    ]),
    _createVNode("button", {
      onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.onMenuClicked && _ctx.onMenuClicked(...args)), ["prevent","stop"])),
      ref: "menuButton",
      class: "menuButton"
    }, [
      _createVNode("div", _hoisted_4, [
        _createVNode("i", {
          style: {"align-self":"center","margin":"0 auto"},
          class: ['far', 'fa-3x', _ctx.menuIcon]
        }, null, 2)
      ]),
      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.menuButtonText), 1)
    ], 512),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withId(() => [
        (_ctx.showMenu)
          ? (_openBlock(), _createBlock(_component_ApplicationMenu, {
              key: 0,
              ref: "dropDownMenu",
              show: _ctx.showMenu
            }, null, 8, ["show"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})